export const hireTypes = ['hireIdea', 'fixedRate', 'offerRate'];

export const HIRE_TYPES_MAP = [
    {
        field: 'hireIdea',
        placeHolder: 'Hire Idea',
    },
    {
        field: 'fixedRate',
        placeHolder: 'Fixed Rate',
    },
    {
        field: 'offerRate',
        placeHolder: 'Offer Rate',
    },
];

const fuelTypesTuple = [
    ['ifo180', 'IFO 180'],
    ['mgo', 'IFO 180'],
    ['vlsfo', 'IFO 180'],
];

export const FUEL_TYPES_MAP = fuelTypesTuple
    .map(([field, placeHolder]) => ({ field, placeHolder }));

/**
 * @typedef {'hireIdea' | 'fixedRate' | 'offerRate'} HireType
 */

export const HiresExportFieldsMapping = new Map([
    ['vessel.imoNumber', { placeHolder: 'Imo number' }],
    ['vessel.name', { placeHolder: 'Name' }],
    ['vessel.blt', { placeHolder: 'Blt' }],
    ['vessel.deadWeight.sDWT', { placeHolder: 'DWT' }],
    ['vessel.typeByPurpose', { placeHolder: 'Type by Purpose' }],
    ['vessel.typeByConstruction', { placeHolder: 'Type by Construction' }],
    ['vessel.geared', { placeHolder: 'Geared' }],
    ['vessel.capacity.grain', { placeHolder: 'Capacity (grain)' }],
    ['vessel.capacity.bale', { placeHolder: 'Capacity (bale)' }],
    ['vessel.capacity.teu', { placeHolder: 'Capacity (teu)' }],
    ['vessel.capacity.feu', { placeHolder: 'Capacity (feu)' }],
    ['vessel.speedConsumptionV2.mode', { placeHolder: 'Speed consumption mode' }],
    ['vessel.speedConsumptionV2.speed', { placeHolder: 'Speed' }],
    ['vessel.speedConsumptionV2.ifo.typeIfo', { placeHolder: 'Consumption ifo type' }],
    ['vessel.speedConsumptionV2.ifo.cons', { placeHolder: 'Consumption ifo' }],
    ['vessel.speedConsumptionV2.mdo.typeMdo', { placeHolder: 'Consumption mdo type' }],
    ['vessel.speedConsumptionV2.mdo.cons', { placeHolder: 'Consumption mdo' }],
    ['vesselDwtGroup.name', { placeHolder: 'Dwt group' }],
    ['vesselDwtGroup.min', { placeHolder: 'Dwt group (min)' }],
    ['vesselDwtGroup.max', { placeHolder: 'Dwt group (max)' }],
    ['placeFrom.name', { placeHolder: 'Place from' }],
    ['regionFrom.name', { placeHolder: 'Region from' }],
    ['regionFrom.mainRegion', { placeHolder: 'Region from (main region)' }],
    ['regionFrom.isInBalticIndex', { placeHolder: 'Region from (baltic index)' }],
    ['delivery.name', { placeHolder: 'Delivery' }],
    ['mainRegionDelivery.name', { placeHolder: 'Main region delivery' }],
    ['placeTo.name', { placeHolder: 'Place to' }],
    ['regionTo.name', { placeHolder: 'Region to' }],
    ['regionTo.mainRegion', { placeHolder: 'Region to (main region)' }],
    ['regionTo.isInBalticIndex', { placeHolder: 'Region to (baltic index)' }],
    ['redelivery.name', { placeHolder: 'Redelivery' }],
    ['mainRegionRedelivery.name', { placeHolder: 'Main region redelivery' }],
    ['lay', { placeHolder: 'Lay' }],
    ['can', { placeHolder: 'Can' }],
    ['hireType', { placeHolder: 'Hire type' }],
    ['hire', { placeHolder: 'Hire' }],
    ['via', { placeHolder: 'Via' }],
    ['duration', { placeHolder: 'Duration' }],
    ['clean', { placeHolder: 'Clean' }],
    ['balastBonus', { placeHolder: 'Balast bonus' }],
    ['intake', { placeHolder: 'Intake' }],
    ['roundTrip', { placeHolder: 'Round trip' }],
    ['fuelPrice.vlsfo', { placeHolder: 'Fuel price (vlsfo)' }],
    ['fuelPrice.mgo', { placeHolder: 'Fuel price (mgo)' }],
    ['fuelPrice.ifo380', { placeHolder: 'Fuel price (ifo380)' }],
    ['bunkerPlace.areaParent', { placeHolder: 'Bunker place (area parent)' }],
    ['bunkerPlace.name', { placeHolder: 'Bunker place (name)' }],
    ['duration', { placeHolder: 'Duration' }],
    ['cargoRegionId.areaParent', { placeHolder: 'Cargo region (area parent)' }],
    ['cargoRegionId.mainRegion', { placeHolder: 'Cargo region (main region)' }],
    ['cargoRegionId.name', { placeHolder: 'Cargo region (name)' }],
    ['cargoTypeId.name', { placeHolder: 'Cargo type' }],
    // ['cargo', { placeHolder: 'Cargo' }],
    ['addedBy.email', { placeHolder: 'Added by (email)' }],
    ['createdAt', { placeHolder: 'Created at' }],
]);



// WEBPACK FOOTER //
// ./app/constants/hire.js